
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    isLogin: { type: Boolean, default: false },
  },

  setup() {
    //
    return {
      //
    };
  },
});
